export enum AnalysisFeePortfolioSetupType {
  SubProduct = "SubProduct",
  RateCard = "RateCard",
  IndustryFund = "IndustryFund",
}
